import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import * as imageConversion from 'image-conversion';
export default {
  name: "ImageUploadComponent",
  setup: function setup() {},
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.$store.dispatch('selectedAvatar');
          case 2:
            _this.selectedAvatar = _context.sent;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    clearPhoto: function clearPhoto() {
      this.$store.commit("updateShowImageUploader", false);
    },
    handleImageSelect: function handleImageSelect(event) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var file, image, reader;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              file = event.target.files[0];
              if (file) {
                // Check if the file is not already in JPG format
                if (file.type !== 'image/jpeg') {
                  try {
                    image = new Image();
                    image.src = URL.createObjectURL(file);
                    image.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                      var canvas, blob, jpgBlob, reader;
                      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while (1) switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return _this2.imageConversion.imagetoCanvas(image);
                          case 2:
                            canvas = _context2.sent;
                            _context2.next = 5;
                            return _this2.imageConversion.canvastoFile(canvas);
                          case 5:
                            blob = _context2.sent;
                            _context2.next = 8;
                            return _this2.imageConversion.compressAccurately(blob, 'image/jpeg');
                          case 8:
                            jpgBlob = _context2.sent;
                            // Convert the Blob to a data URL
                            reader = new FileReader();
                            reader.onload = function () {
                              // Set the converted JPG image in the Vuex store
                              _this2.$store.commit("updatePhoto", reader.result);
                            };
                            reader.readAsDataURL(jpgBlob);
                          case 12:
                          case "end":
                            return _context2.stop();
                        }
                      }, _callee2);
                    }));
                  } catch (error) {
                    console.error('Image conversion error:', error);
                  }
                } else {
                  // The selected image is already in JPG format, so just set it in the Vuex store
                  reader = new FileReader();
                  reader.onload = function () {
                    _this2.$store.commit("updatePhoto", reader.result);
                  };
                  reader.readAsDataURL(file);
                }
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  },
  data: function data() {
    return {
      selectedAvatar: null,
      imageConversion: imageConversion,
      seeIdeas: false,
      imageFile: null
    };
  }
};